import { TranslationService } from '@rocheglobal/component-library-dot-com/src/services/translation';
import { useEffect, useState } from 'react';

export function useTranslation(
  key: string,
  options: {
    capitalize?: boolean;
  } = {},
) {
  const [translation, setTranslation] = useState<string>('');

  useEffect(() => {
    const getTranslation = async () => {
      let t = await TranslationService.translate(key);

      if (options.capitalize) {
        t = t.charAt(0).toUpperCase() + t.slice(1);
      }

      setTranslation(t);
    };
    getTranslation();
  }, []);

  return translation;
}
